import Icon from '../components/Icon';

const Weather44 = Icon(
  'weather-44',
  <>
    <path d="M2.5 12c0-.312.2-.565.448-.565h3.437c.248 0 .448.253.448.565s-.2.565-.448.565H2.948c-.247 0-.448-.253-.448-.565M9.833 12c0-.312.201-.565.448-.565h3.438c.247 0 .448.253.448.565s-.201.565-.448.565h-3.437c-.248 0-.449-.253-.449-.565M17.615 11.435c-.248 0-.448.253-.448.565s.2.565.448.565h3.437c.247 0 .448-.253.448-.565s-.2-.565-.448-.565z" />
  </>
);

export default Weather44;
